import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectConfig } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PataviumRole } from '../../../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { DataService } from '../../../../../services/data.service';
import { NotificationService } from '../../../../../services/notification.service';
import { AutocompleteService } from '../../../../../services/autocomplete.service';
import { UserlistComponent } from '../../../../common/userlist/userlist.component';
import { ContractPermission } from '../../../../../models/request-and-responses/rest-api/enums/contractPermission';
import { AuthService } from '../../../../../services/auth.service';
import { LocalStorageService } from '../../../../../services/local-storage.service';

@Component({
    selector: 'app-admin-users-agents',
    templateUrl: '../../../../common/userlist/userlist.component.html',
    styleUrls: ['../../../../common/userlist/userlist.component.css']
})
export class AdminUsersAgentsComponent extends UserlistComponent implements OnInit {
    constructor(
        protected toastr: ToastrService,
        protected api: DataService,
        protected modalService: NgbModal,
        protected modalConfig: NgbModalConfig,
        protected config: NgSelectConfig,
        protected notification: NotificationService,
        protected ptautocomplete: AutocompleteService,
        protected ngxService: NgxUiLoaderService,
        protected authService: AuthService,
        protected localStorage: LocalStorageService
    ) {
        super(
            toastr,
            api,
            modalService,
            modalConfig,
            config,
            notification,
            ptautocomplete,
            ngxService,
            authService,
            localStorage
        );
        this.usersRole = PataviumRole.Agent;
        this.preferredPermitContract = ContractPermission.Self;
    }

    ngOnInit() {
        super.ngOnInit();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/admin/users/agents/users.agents.component.ts